import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import {
  faHeart,
  faTruck,
  faHeartbeat,
  faSquareRootAlt,
  faChartLine,
  faSignal,
  faChartPie,
  faDollyFlatbed,
  faCoins,
  faReceipt,
  faFileWord,
  faChartBar,
  faCopy,
  faUser as faHuman,
} from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { AppService } from '@Services/app.service';
import { UtilityService } from '@Services/utility.service';
import { SearchService } from '@Shared/components/search/search-extras/search.service';
import { environment } from '@environments/environment';
import { SalesAppService } from 'projects/evolutics-sales-ui/src/app/services/sales-app.service';
import { IMenuItem, MenuItem } from '@Shared/models/IMenuItem';
import { SalesMenuItem } from 'projects/evolutics-sales-ui/src/app/models/sales.IMenuItem';
import { TranslatePipe } from '../../../../../evolutics-shared-lib/src/lib/Shared/pipes/translate.pipe';
import { AsyncPipe } from '@angular/common';
import { NavbarSearchComponent } from '../../../../../evolutics-shared-lib/src/lib/Shared/components/search/search-components/navbar-search/navbar-search.component';

@Component({
    selector: 'sui-top-nav',
    templateUrl: './top-nav.component.html',
    styleUrls: ['./top-nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, RouterLinkActive, NavbarSearchComponent, AsyncPipe, TranslatePipe]
})
export class TopNavComponent implements OnInit {

  faHeart = faHeart;
  faTruck = faTruck;
  faHeartbeat = faHeartbeat;
  faSquareRootAlt = faSquareRootAlt;
  faDollyFlatbed = faDollyFlatbed;
  faChartLine = faChartLine;
  faChartPie = faChartPie;
  faSignal = faSignal;
  faCoins = faCoins;
  faReceipt = faReceipt;
  faFileWord = faFileWord;
  faChartBar = faChartBar;
  navColor = '';
  system = '';
  faCopy = faCopy;
  faHumn = faHuman;
  routeSub: Subscription;
  topMenu = environment.menus;

  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
    public appS: AppService,
    public sappS: SalesAppService,
    public uS: UtilityService,
    public sS: SearchService
  ) {
    this.routeSub = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route: any) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route: any) => route.data)
      )
      .subscribe((event: any) => {
        console.log(event);
        if (event['color'] && event['system']) {
          this.navColor = event['color'].toString();
          this.system = event['system'].toString();
          document.getElementsByTagName('body')[0].className = this.system;
        }
      });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.routeSub.unsubscribe();
  }
  setCurrentMenu(item: MenuItem) {
    console.log(item)
    this.sappS.setCurrentTopMenu(item.system);
  }

}
